import graphql__036b4c3076264270115a from "./__generated__/ContributionEditRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";
import ModalErrorBoundary from "../ErrorBoundaries/ModalErrorBoundary";

import ModalLoader from "../Modals/ModalLoader";
import ContributionForm from "../ParticipativeModule/ContributionForm";

const ContributionEditRoute = props => {
  const { participativeModuleSlug, contributionSlug } = useParams();

  return (
    <AppQueryRenderer
      key={contributionSlug}
      query={ContributionEditRouteQuery}
      variables={{ participativeModuleSlug, contributionSlug }}
      additionalProps={{ ...props, edit: true }}
      component={ContributionForm}
      loader={<ModalLoader />}
      ErrorBoundary={ModalErrorBoundary}
      // Ensure that the contribution object is always reloaded from the server when the
      // route is accessed, to avoid an already edited contribution to be used from the
      // store which can prevent the form to be accessed by the user after he already
      // edited the contribution in the same session.
      fetchPolicy="network-only"
    />
  );
};

const ContributionEditRouteQuery = graphql__036b4c3076264270115a;

export default ContributionEditRoute;
